import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Container, Reveal, SectionHeader } from "./common";

const faqs = [
    {
        q: "What is Kryvo CRM?",
        a: "Kryvo CRM is a modern customer relationship management platform by Kryvo Technologies. It helps growing businesses manage leads, contacts, accounts, opportunities, pipelines, tasks, quotations, invoices, field sales, customer engagement, automation and analytics — in one connected workspace.",
    },
    {
        q: "Who is Kryvo CRM for?",
        a: "Kryvo is built for growing sales teams — from small businesses moving off spreadsheets to mid-sized companies that need automation, field sales management and multi-channel engagement without enterprise-level complexity.",
    },
    {
        q: "Can I migrate from spreadsheets?",
        a: "Yes. You can import leads, contacts and accounts directly from spreadsheets, and our team will help you map your columns to Kryvo fields during onboarding so nothing gets lost.",
    },
    {
        q: "Can Kryvo support different sales processes?",
        a: "Absolutely. Pipelines, stages, fields and workflows are customizable, so Kryvo adapts to how your team sells — whether that's real estate bookings, recruitment placements or B2B deals.",
    },
    {
        q: "Does Kryvo support field sales?",
        a: "Yes. Kryvo includes field sales management: planned visits, optimized routes, GPS check-ins, visit logs, expense tracking and team performance views for managers. Ask us about availability for your team during your demo.",
    },
    {
        q: "Does Kryvo support email and WhatsApp engagement?",
        a: "Yes. Kryvo Engage lets you run email campaigns, automated sequences and WhatsApp marketing directly from your CRM data, with templates, scheduling and engagement analytics built in.",
    },
    {
        q: "Can I start with a small team?",
        a: "Yes — many customers start with just 3–5 users. Kryvo is designed to be simple on day one, and it grows with you as your team and sales process mature.",
    },
    {
        q: "Is there a free trial?",
        a: "Yes. Every plan includes a 14-day free trial with no credit card required, and you can cancel anytime.",
    },
    {
        q: "Can Kryvo grow with my business?",
        a: "That's the core idea: simple today, powerful tomorrow. Start with lead and pipeline management, then turn on automation, engagement, field sales and analytics as you scale — without migrating to a new system.",
    },
];

const FAQ = () => (
    <section id="faq" data-testid="faq-accordion-section" className="bg-white py-20 lg:py-28">
        <Container>
            <SectionHeader
                eyebrow="FAQ"
                title="Questions, answered."
                sub="Everything growing teams usually ask before starting with Kryvo."
            />
            <Reveal delay={0.15}>
                <div className="mx-auto mt-12 max-w-3xl">
                    <Accordion type="single" collapsible className="grid gap-3">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="rounded-2xl border border-[#E5E7EB] bg-white px-6 shadow-sm transition-colors data-[state=open]:border-[#16A34A]/30 data-[state=open]:bg-[#F7FEF9]"
                            >
                                <AccordionTrigger className="py-5 text-left font-display text-[15px] font-bold text-[#111827] hover:no-underline [&[data-state=open]]:text-[#15803D]">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#64748B]">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </Reveal>
        </Container>
    </section>
);

export default FAQ;
